import { render, staticRenderFns } from "./modbus.vue?vue&type=template&id=62ec5a5c&scoped=true&"
import script from "./modbus.vue?vue&type=script&lang=js&"
export * from "./modbus.vue?vue&type=script&lang=js&"
import style0 from "./modbus.vue?vue&type=style&index=0&id=62ec5a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ec5a5c",
  null
  
)

export default component.exports